var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":""}},[(false)?_c('contract-upgrade-calculator',{attrs:{"preisKombiAbo":690,"vertragsEndDatum":"2024-12-06"}}):_vm._e(),(false)?_c('employee-list'):_vm._e(),(true)?_c('album-manager'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }